<script setup>
    // Component
    import MainHeader from '@/components/HeaderComponent.vue';

    // Vue
    import { onMounted, ref } from 'vue';
    import { useRouter } from 'vue-router';

    // Store
    import { useCommonStore } from '@/stores/common/commonStore';
    import { useReserveStore } from '@/stores/reserve/reserveStore';
    import { useLanguageStore } from '@/stores/common/languageStore';
    import { useLoginStore } from '@/stores/login/loginStore';

    // ----------------------------
    // 定数
    // ----------------------------
    const router = useRouter();

    // 定数
    const commonStore = useCommonStore();
    const reserveStore = useReserveStore();
    const languageStore = useLanguageStore();
    const loginStore = useLoginStore();
    const from = commonStore.from;
    // ----------------------------
    // リアクティブ変数
    // ----------------------------
    const message = ref('');

    // ----------------------------
    // 関数
    // ----------------------------
    // ホームに戻るボタン押下時
    function onHome() {
        router.push('/home');
    }
    // ----------------------------
    // ライフサイクル
    // ----------------------------
    onMounted(() => {
        message.value = reserveStore.serviceDetail.ServiceGuide
        reserveStore.clearAll();
        commonStore.from = '';
    });
</script>

<template>
    <section id="main">
        <MainHeader />
        <div id="contents">
            <div class="whiteBox">
                <h3 class="reserve">
                    <span>{{ $t('reservePlanningComplete.parts.pageTitle1') }}</span>
                    <!-- ステップ表示 -->
                    <template v-if="languageStore.getLanguageValue === '1'">
                        <template v-if="from === 'consultation'">
                            <!--予約(相談内容から利用方法等選択)画面からのルート-->
                            <img src="/img/step/mode1_step6.png" class="step" width="410" height="46" />
                        </template>
                        <template v-if="from === 'program'">
                            <!--予約(プログラムからサービス選択)画面からのルート-->
                            <img src="/img/step/mode2_step6.png" class="step" width="410" height="46" />
                        </template>
                        <template v-else-if="from === 'personal'">
                            <!--予約(プログラムから利用方法など選択)画面からのルート-->
                            <img src="/img/step/mode3_step6.png" class="step" width="410" height="46" />
                        </template>
                    </template>
                    <template v-else>
                        <template v-if="from === 'consultation'">
                            <!--予約(相談内容から利用方法等選択)画面からのルート-->
                            <img src="/img/step/mode1_step6_en.png" class="step" width="410" height="46" />
                        </template>
                        <template v-if="from === 'program'">
                            <!--予約(プログラムからサービス選択)画面からのルート-->
                            <img src="/img/step/mode2_step6_en.png" class="step" width="410" height="46" />
                        </template>
                        <template v-else-if="from === 'personal'">
                            <!--予約(プログラムから利用方法など選択)画面からのルート-->
                            <img src="/img/step/mode3_step6_en.png" class="step" width="410" height="46" />
                        </template>
                    </template>
                </h3>
                <section class="whiteBoxContents scroll">
                    <!-- ステップ表示 -->
                    <template v-if="languageStore.getLanguageValue === '1'">
                        <template v-if="from === 'consultation'">
                            <!--予約(相談内容から利用方法等選択)画面からのルート-->
                            <img src="/img/step/mode1_step6.png" class="step" width="410" height="46" />
                        </template>
                        <template v-if="from === 'program'">
                            <!--予約(プログラムからサービス選択)画面からのルート-->
                            <img src="/img/step/mode2_step6.png" class="step" width="410" height="46" />
                        </template>
                        <template v-else-if="from === 'personal'">
                            <!--予約(プログラムから利用方法など選択)画面からのルート-->
                            <img src="/img/step/mode3_step6.png" class="step" width="410" height="46" />
                        </template>
                    </template>
                    <template v-else>
                        <template v-if="from === 'consultation'">
                            <!--予約(相談内容から利用方法等選択)画面からのルート-->
                            <img src="/img/step/mode1_step6_en.png" class="step" width="410" height="46" />
                        </template>
                        <template v-if="from === 'program'">
                            <!--予約(プログラムからサービス選択)画面からのルート-->
                            <img src="/img/step/mode2_step6_en.png" class="step" width="410" height="46" />
                        </template>
                        <template v-else-if="from === 'personal'">
                            <!--予約(プログラムから利用方法など選択)画面からのルート-->
                            <img src="/img/step/mode3_step6_en.png" class="step" width="410" height="46" />
                        </template>
                    </template>
                    <p class="pageInfo">
                        {{ $t('reservePlanningComplete.parts.pageInformation1') }}<br />
                        {{ $t('reservePlanningComplete.parts.pageInformation2') }}<a href="/reserve/list" class="btnText">{{ $t('reservePlanningComplete.parts.button1') }}</a>
                        {{ $t('reservePlanningComplete.parts.pageInformation3') }}
                    </p>
                    <hr class="line" style="margin-bottom: 23px" />
                    <div class="pageSubInfo">
                        {{ $t('reservePlanningComplete.parts.pageInformation4') }}
                        <a href="/user/detail" class="btnText">{{ $t('reservePlanningComplete.parts.button2') }}</a>
                        {{ $t('reservePlanningComplete.parts.pageInformation5') }}
                        <ul id="reserveUserInfo">
                            <li>
                                <ul>
                                    <li>{{ $t('reservePlanningComplete.parts.pageInformation6') }}</li>
                                    <li>{{ loginStore.phoneNumber }}</li>
                                </ul>
                            </li>
                            <li>
                                <ul>
                                    <li>{{ $t('reservePlanningComplete.parts.pageInformation7') }}</li>
                                    <li>{{ loginStore.mailAddress }}</li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                    <div class="message" style="white-space: pre-wrap; overflow-wrap:break-word">{{ message }}</div>
                </section>
                <section class="whiteBoxFooter">
                    <ul class="btnArea center">
                        <li>
                            <button type="button" class="btnPrimary" @click="onHome">{{ $t('reservePlanningComplete.parts.button3') }}</button>
                        </li>
                    </ul>
                </section>
            </div>
        </div>
    </section>
</template>

<style></style>
